import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { createKey } from "../../api/admin";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { ApiKeyRow } from "./ApiKeyRow";

const SCOPES = ["attendance:read", "employees:read"];

export const ApiKeyPanel = ({ keys, reload }) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [scopes, setScopes] = useState(SCOPES);
  const [fresh, setFresh] = useState("");

  const create = async () => {
    if (!name) return;
    const res = await createKey({ name, scopes });
    setFresh(res.api_key);
    setName("");
    toast.success(t("api.created"));
    reload();
  };

  return (
    <NeuCard data-testid="api-key-panel">
      <p className="label-xs">{t("api.keys")}</p>
      <div className="mt-4 flex flex-wrap items-end gap-3">
        <div className="min-w-0 flex-1 basis-full sm:basis-[200px]">
          <NeuInput
            data-testid="api-key-name"
            placeholder={t("api.keyName")}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          {SCOPES.map((s) => (
            <button
              key={s}
              type="button"
              data-testid={`api-scope-${s}`}
              onClick={() => setScopes((p) => (p.includes(s) ? p.filter((x) => x !== s) : [...p, s]))}
              className={`rounded-full border px-3 py-2 font-mono text-[11px] ${
                scopes.includes(s) ? "border-primary/50 text-primary shadow-neu-in" : "border-border/60 text-muted-foreground shadow-neu-sm"
              }`}
            >
              {s}
            </button>
          ))}
        </div>
        <NeuButton variant="primary" data-testid="api-key-create" onClick={create}>
          {t("api.createKey")}
        </NeuButton>
      </div>

      {fresh ? (
        <div className="mt-4 rounded-2xl border border-primary/40 p-4 shadow-neu-in" data-testid="api-key-fresh">
          <p className="text-xs text-muted-foreground">{t("api.copyOnce")}</p>
          <div className="mt-2 flex items-center gap-2">
            <code className="break-all font-mono text-xs text-primary">{fresh}</code>
            <NeuButton className="px-3 py-2" onClick={() => navigator.clipboard?.writeText(fresh)}>
              <Copy className="h-4 w-4" />
            </NeuButton>
          </div>
        </div>
      ) : null}

      <ul className="mt-5 space-y-3">
        {keys.map((k) => (
          <ApiKeyRow key={k.id} item={k} reload={reload} />
        ))}
      </ul>
    </NeuCard>
  );
};
